export default __webpack_public_path__ + "static/media/icon_mark.76abe87b.svg";